import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from '../views/Dashboard.vue';
import DashboardInsights from '../components/dashboard/Views/Insights.vue';
import DashboardExplorer from '../components/dashboard/Views/Explorer.vue';
import DashboardSalesInsights from '../components/dashboard/Views/SalesInsights.vue';
import DashboardBenchmarks from '../components/dashboard/Views/Benchmarks.vue';
import DashboardDemographics from '../components/dashboard/Views/Demographics.vue';
import DashboardExecutiveView from '../components/dashboard/Views/Executive.vue';
import DashboardSavedReports from '../components/dashboard/Views/SavedReports.vue';

Vue.use(Router);

const PUBLIC_ROUTE = { isPublic: true };
const SELF_SERVE_ROUTE = { isPublic: false, selfServe: true };

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      meta: SELF_SERVE_ROUTE,
      redirect: '/dashboard',
    },
    {
      path: '/dashboard',
      redirect: '/dashboard/insights',
      component: Dashboard,
      meta: SELF_SERVE_ROUTE,
      children: [
        {
          name: 'insights-base',
          path: 'insights',
          component: DashboardInsights,
          meta: SELF_SERVE_ROUTE,
          children: [
            {
              name: 'insights-id',
              path: ':dashboardReportId',
              redirect: '/dashboard/insights',
              component: DashboardInsights,
              meta: SELF_SERVE_ROUTE,
            },
          ],
        },
        {
          name: 'explorer-base',
          path: 'explorer',
          component: DashboardExplorer,
          meta: SELF_SERVE_ROUTE,
          children: [
            {
              name: 'explorer-id',
              path: ':dashboardReportId',
              component: DashboardExplorer,
              meta: SELF_SERVE_ROUTE,
            },
          ],
        },
        {
          name: 'sales-insights-base',
          path: 'sales-insights',
          component: DashboardSalesInsights,
          meta: SELF_SERVE_ROUTE,
          children: [
            {
              name: 'sales-insights-id',
              path: ':dashboardReportId',
              redirect: '/dashboard/sales-insights',
              component: DashboardSalesInsights,
              meta: SELF_SERVE_ROUTE,
            },
          ],
        },
        {
          name: 'benchmarks',
          path: 'benchmarks',
          redirect: '/dashboard/benchmarks/category',
          component: DashboardBenchmarks,
          meta: SELF_SERVE_ROUTE,
          children: [
            {
              name: 'benchmarks-brand-base',
              path: 'brand',
              component: DashboardBenchmarks,
              meta: SELF_SERVE_ROUTE,
              children: [
                {
                  name: 'benchmarks-brand-id',
                  path: ':benchmarksBrandId',
                  redirect: '/dashboard/benchmarks/brand',
                  component: DashboardBenchmarks,
                  meta: SELF_SERVE_ROUTE,
                },
              ],
            },
            {
              name: 'benchmarks-category-base',
              path: 'category',
              component: DashboardBenchmarks,
              meta: SELF_SERVE_ROUTE,
              children: [
                {
                  name: 'benchmarks-category-id',
                  path: ':benchmarksCategoryId',
                  redirect: '/dashboard/benchmarks/category',
                  component: DashboardBenchmarks,
                  meta: SELF_SERVE_ROUTE,
                },
              ],
            },
          ],
        },
        {
          name: 'demographics-base',
          path: 'shopper-intelligence',
          component: DashboardDemographics,
          meta: SELF_SERVE_ROUTE,
          children: [
            {
              name: 'demographics-id',
              path: ':demographicsReportId',
              component: DashboardDemographics,
              meta: SELF_SERVE_ROUTE,
            },
          ],
        },
        {
          name: 'executive-base',
          path: 'executive',
          component: DashboardExecutiveView,
          meta: SELF_SERVE_ROUTE,
        },
        {
          name: 'saved-reports-base',
          path: 'saved-reports',
          component: DashboardSavedReports,
          meta: SELF_SERVE_ROUTE,
        },
      ],
    },
    {
      name: 'login-redirect',
      path: '/login-redirect',
      meta: PUBLIC_ROUTE,
    },
  ],
});
